import { Component, OnInit, Input } from '@angular/core';
import { IssueStateGroupFront } from '../../../models/api.models';

@Component({
  selector: 'app-issue-stategroup-chip',
  templateUrl: './issue-stategroup-chip.component.html',
  styleUrls: ['./issue-stategroup-chip.component.scss'],
})
export class IssueStategroupChipComponent implements OnInit {

   @Input() issueStateGroupFront: IssueStateGroupFront = new IssueStateGroupFront();

  constructor() { }

  ngOnInit() {}

}
